<template>
  <div>
    <div v-if="!containers_list">
      <v-btn color="#6dbe45" large style="width: 130px">
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </v-btn>
    </div>
    <!-- Progress bar starts -->
    <div v-else>
      <v-stepper
        class="form"
        v-model="e1"
        style="background: none; height: 20%"
      >
        <CartPopup />
        <div class="currentObject justify-content-center" v-if="e1 != 5">
          <h5>
            {{ currentSurveyObject.description }},
            <strong>&nbsp;{{ currentSurveyObject.market_city }}</strong>
          </h5>
          <img
            id="currentItem"
            :src="currentSurveyObject.imageurl"
            alt="curentLineItem"
            style="border-radius: 50px"
          />
        </div>
        <br />
        <h3 style="font-weight: bold">Step {{ e1 }}/4</h3>
        <v-stepper-header
          style="
            border-radius: 10px;
            background-color: #f4f4f4;
            opacity: 0.9;
            display: none;
          "
        >
          <v-stepper-step :complete="e1 > 1" step="1"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4"></v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <p>
              Next Off Stack, Colour Cannot Be Selected (please review
              <a target="_blank" style="color: #6dbe45" :href="samplePicsHref"
                >sample photos</a
              >
              before making your selections).
            </p>
            <NeworUsed />
            <v-btn
              relative
              color="#6dbe45"
              class="btns continue_btns"
              medium
              @click="e1 = 2"
              style="color: #ffffff"
              >Continue</v-btn
            >
          </v-stepper-content>
          <!-- Storage/Export -->
          <v-stepper-content step="2">
            <p>Will you be using your container for storage or shipment?</p>
            <Purpose />
            <v-btn
              relative
              class="my-2 btns"
              medium
              style="color: #6dbe45"
              text
              @click="e1 = 1"
              >Previous</v-btn
            >
            <v-btn
              relative
              color="#6dbe45"
              class="btns continue_btns"
              medium
              @click="getContainer()"
              style="color: #ffffff"
              >Continue</v-btn
            >
          </v-stepper-content>
          <!-- Delivery-->
          <v-stepper-content step="3">
            <p>
              Please make sure you have
              <a style="color: #6dbe45" target="_blank" :href="spaceTruckHref"
                >space for the truck</a
              >
              before selecting delivery.
            </p>
            <Delivery />
            <v-btn
              relative
              class="btns"
              medium
              style="color: #6dbe45; font-weight: bold"
              text
              @click="e1 = 2"
              >Previous</v-btn
            >
            <v-btn
              relative
              color="#6dbe45"
              class="btns continue_btns"
              medium
              @click="checkCart()"
              style="color: #ffffff"
              >Continue</v-btn
            >
          </v-stepper-content>
          <!-- Last Subsection-->
          <v-stepper-content step="4">
            <div class="lastForm" v-if="finalItem">
              <h4>This is your container</h4>
              <v-flex key="20">
                <div class="mx-auto pa3">
                  <img :src="finalItem.image" />
                  <h5 style="margin-top: 10px">{{ finalItem.title }}</h5>
                  <h6>
                    {{ finalItem.condition }} ({{ type.toLowerCase() }}),
                    {{ finalItem.market_city }}
                  </h6>
                  <h4>Price: ${{ format(finalItem.price) }}</h4>
                </div>
              </v-flex>
              <div class="add" style="display: inline">
                <v-btn
                  text
                  relative
                  class="btns"
                  medium
                  style="color: #6dbe45"
                  @click="e1 = 3"
                  >Previous</v-btn
                >
                <v-btn
                  v-if="finalItem.availableForSale"
                  relative
                  color="#6dbe45"
                  class="btns continue_btns"
                  medium
                  style="color: #ffffff"
                  @click="updateCart()"
                  >{{ addtocartMessage }}</v-btn
                >
                <v-btn
                  v-else
                  relative
                  color="#ffffff"
                  class="btns continue_btns"
                  medium
                  style="color: #00587d"
                  >Out Of Stock</v-btn
                >
              </div>
            </div>
            <div v-else>
              Could not find any container based on your selections!!!
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <br />
  </div>
</template>

<script>
import NeworUsed from "./pages/NeworUsed";
import Purpose from "./pages/Purpose";
import Delivery from "./pages/Delivery";
import axios from "axios";
import CartPopup from "../FixedComponents/CartPopup.vue";
import { mapGetters, mapActions } from "vuex";
import * as country_based_data from "@/JS/CountryBasedData";
import * as types from "@/store/types";
import { formatNumber } from "@/JS/FormatNumber";

export default {
  name: "Forms",
  components: {
    NeworUsed,
    Purpose,
    Delivery,
    CartPopup,
  },
  mounted() {
    if (this.containers_list) {
      window.scrollTo(0, 0);
      this.intializeSurveyObject();
      if (this.cscSurvey === null) this.getCSCShopify(); //initialize global cscsurvey object cscsurvey if it is null
      this.initializeCountryBasedHref(); //Assign sample photos, space delivery for USA/Canda
    } else this.$router.push("/");
  },
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
      VUEX_ZIPCODE: types.ZIPCODE,
      CART: types.CART_LIST,
      containers_list: types.CONTAINER_LIST,
      cscTerms: types.CSC_TERMS,
      cscSurvey: types.CSC_SURVEY,
      currentSurveyObject: types.CURRENTSURVEYOBJECT,
      delivery: types.DELIVERY,
      type: types.TYPE,
      purpose: types.PURPOSE,
    }),
  },
  data() {
    return {
      e1: 1,
      newSku: "",
      finalItem: null,
      formvalidationError: false,
      addtocartMessage: "Add To Cart",
      samplePicsHref: "",
      spaceTruckHref: "",
    };
  },
  methods: {
    ...mapActions({
      updateCscTerms: types.ACTIONS_UPDATE_CSC_TERMS,
      updateCscSurvey: types.ACTIONS_UPDATE_CSC_SURVEY,
      updatePurpose: types.ACTIONS_UPDATE_PURPOSE,
      updateType: types.ACTIONS_UPDATE_TYPE,
      updateCurrentSurveyPurpose: types.ACTIONS_UPDATE_CURRENTSURVEY_PURPOSE,
      updateCurrentSurveyType: types.ACTIONS_UPDATE_CURRENTSURVEY_TYPE,
      updateDelivery: types.ACTIONS_UPDATE_DELIVERY,
      updateLineItemHaulerPrice: types.ACTIONS_UPDATE_LINEITEMHAULERPRICE,
      updateLineItemMarket: types.ACTIONS_UPDATE_LINEITEMMARKET,
      updateLineItemCustomAttribute: types.ACTIONS_UPDATE_CART_CUSTOMATTRIBUTE,
      updateLineItemCSCSurvey: types.ACTIONS_UPDATE_CART_CSCSURVEY,
      deleteLineItemCSCSurvey: types.ACTIONS_DELETE_CART_CSCSURVEY,
      updateDeleteCartItem: types.ACTIONS_REMOVE_CARTITEM,
      addCartItem: types.ACTIONS_UPDATE_CART_LIST,
    }),
    initializeCountryBasedHref() {
      if (this.COUNTRY_CODE === "US") {
        this.samplePicsHref = country_based_data.USASamplePhotos;
        this.spaceTruckHref = country_based_data.USASpaceTruckLink;
      } else if (this.COUNTRY_CODE === "CA") {
        this.samplePicsHref = country_based_data.CanadaSamplePhotos;
        this.spaceTruckHref = country_based_data.CanadaSpaceTruckLink;
      }
    },
    intializeSurveyObject() {
      //update survey objects in the 3rd page from currentSurveyObject
      var title = this.currentSurveyObject.description;
      if (title.includes("10")) this.updateCurrentSurveyPurpose("STORAGE");
      if (title.includes("45")) this.updateCurrentSurveyType("USED");

      this.updateCscTerms(this.currentSurveyObject.cscterms);
      this.updatePurpose(this.currentSurveyObject.purpose);
      this.updateType(this.currentSurveyObject.type);
      this.updateDelivery(this.currentSurveyObject.delivery);
    },
    getCSCShopify() {
      //get CSC SURVEY from shopify
      var url, tokenID;
      var query =
        `query getProducts {
                products
                (
                    query:"` +
        "MODCSC" +
        `"
                    first:1
                    sortKey: PRICE
                    reverse: false
            )
            {
              edges{
                node{
                  id
                  title
                  handle
                  tags
                  variants(first:50, sortKey:POSITION) {
                    edges{
                      node{
                        id
                        sku
                        availableForSale
                        image {
                          id
                          originalSrc
                          transformedSrc
                          altText
                        }
                        selectedOptions{
                          name
                          value
                        }
                        title
                        price {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          } `;

      if (this.COUNTRY_CODE === "US") {
        url = country_based_data.USAShopifyStorefrontUrl;
        tokenID = country_based_data.USAStorefrontAccessToken;
      } else if (this.COUNTRY_CODE === "CA") {
        url = country_based_data.CanadaShopifyStorefrontUrl;
        tokenID = country_based_data.CanadaStorefrontAccessToken;
      }
      var headers_list = {
        "X-Shopify-Storefront-Access-Token": tokenID,
        "content-type": "application/json",
      };
      var data = { query: query };
      axios.post(url, data, { headers: headers_list }).then((res) => {
        var csc =
          res.data["data"]["products"]["edges"][0]["node"]["variants"][
            "edges"
          ][0]["node"];
        this.updateCscSurvey({
          key: csc.sku,
          id: csc.id,
          image: csc.image.originalSrc,
          price: csc.price.amount,
          quantity: 1,
        });
      });
    },
    getContainer() {
      //get WWT or OTC or CWO based on user inputs
      if (this.type === "NEW") this.appendToSku("OTC");
      else if (this.purpose === "EXPORT") this.appendToSku("CWO");
      else if (this.purpose === "STORAGE") this.appendToSku("WWT");

      this.updateLineItemHaulerPrice(this.finalItem.haulingPrice);
      this.updateLineItemMarket(this.finalItem.market_city);
      this.e1 = 3;
    },
    appendToSku(condition) {
      this.newSku = this.currentSurveyObject.formattedSku + condition;
      this.addLineItems();
    },
    addLineItems() {
      for (var key in this.containers_list.products) {
        if (key.endsWith(this.newSku)) {
          const data = {
            image: this.containers_list["products"][key][0]["image_url"],
            sku: this.containers_list["products"][key][0]["sku"],
            title: this.containers_list["products"][key][0]["container_size"],
            formattedSku: this.currentSurveyObject.formattedSku,
            price: this.containers_list["products"][key][0]["container_price"],
            condition: this.containers_list["products"][key][0]["condition"],
            id: this.containers_list["products"][key][0]["id"],
            haulingPrice: this.containers_list["products"][key][0][
              "hauling_price"
            ],
            market_city: this.containers_list["products"][key][0][
              "market_city"
            ],
            depot_address_fields: this.containers_list["products"][key][0][
              "depot_address_fields"
            ],
            availableForSale: this.containers_list["products"][key][0][
              "availableForSale"
            ],
          };
          this.finalItem = data;
          return;
        }
      }
    },
    updateCart() {
      //If new sku item already present, change the custom Attributes
      //If new Sku is present - oldsku is not empty(coming from last page) and newSku is different from oldSku, Delete the oldSku
      //If newSku is not present and oldsku empty(coming from second page) then just add  newSku Item
      //If newSku is not present and oldsku is not empty(coming from last page) remove oldsku
      const oldSku = this.currentSurveyObject.oldSku;
      if (this.addtocartMessage === "Update") {
        this.updateQuantity();
        if (this.finalItem.sku != oldSku && oldSku) this.removeItem(oldSku);
      } else {
        if (oldSku) this.removeItem(oldSku);
        this.addCart();
      }
      this.$router.push("/purchase/container/cart");
    },
    updateQuantity() {
      //add predelivery/prepickup survey, check if CSC Survey was added or removed. If it was present but removed while updating delete the key CSCSurvey from lineItem
      var keySku = this.finalItem.sku;
      var itemindex, sku;
      for (itemindex in this.CART) {
        sku = this.CART[itemindex].sku;
        if (sku === keySku) {
          var customAttributes = {
            CSCSurveyRequired: this.cscTerms && this.purpose === "EXPORT",
            Type: this.type,
            Purpose: this.purpose,
            Delivery: this.delivery,
          };
          this.updateLineItemCustomAttribute({
            itemindex: itemindex,
            customAttributes: customAttributes,
          });
          if (this.cscTerms && this.purpose === "EXPORT")
            this.updateLineItemCSCSurvey(itemindex);
          else if ("CSCSurvey" in this.CART[itemindex])
            this.deleteLineItemCSCSurvey(itemindex);

          this.$toast("Updated", {
            id: "auto",
            type: "warning",
            position: "top-center",
          });
          this.maintainLocalStorageCart();
          break;
        }
      }
    },
    removeItem(oldSku) {
      var itemindex, sku;
      for (itemindex in this.CART) {
        sku = this.CART[itemindex].sku;
        if (oldSku === sku) {
          this.updateDeleteCartItem(itemindex);
          this.maintainLocalStorageCart();
          break;
        }
      }
    },
    addCart() {
      var customAttributes = {
        CSCSurveyRequired: this.cscTerms && this.purpose === "EXPORT",
        Type: this.type,
        Purpose: this.purpose,
        Delivery: this.delivery,
      };
      var data = new Object();
      data = this.finalItem;
      data["quantity"] = 1;
      data["customAttributes"] = customAttributes;
      if (this.cscTerms && this.purpose === "EXPORT")
        data["CSCSurvey"] = this.cscSurvey;

      this.addCartItem(data);
      this.maintainLocalStorageCart();
      this.$toast("Added", {
        id: "auto",
        type: "success",
        position: "top-center",
      });
    },
    checkCart() {
      //check if sku already present in the cart or not. If peresent change the button messgae to UPDATE.
      var keySku = this.finalItem.sku;
      var itemindex, sku;
      var found = false;
      for (itemindex in this.CART) {
        sku = this.CART[itemindex].sku;
        if (sku === keySku) {
          found = true;
          break;
        }
      }
      if (found) this.addtocartMessage = "Update";
      else this.addtocartMessage = "Add To Cart";
      this.formvalidationError = false;
      this.e1 = 4;
    },
    maintainLocalStorageCart() {
      const containerdetailes = JSON.stringify(this.CART);
      localStorage.setItem("containerdetailes", containerdetailes);
    },
    format(num) {
      return formatNumber(num);
    },
  },
};
</script>

<style scoped>
.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
}

.continue_btns {
  border-radius: 15px;
  box-shadow: 1px 1px 1px 1px #ffffff;
  margin: 10px;
}

.form {
  margin: auto;
  width: 80%;
  padding: 10px;
  text-align: center;
  color: white;
}

strong {
  font-size: 90%;
  padding-bottom: 10px;
  padding-top: 5px;
}

.lastForm img {
  max-width: 250px;
  border-radius: 25px;
}

#currentItem {
  width: 100px;
  height: 100px;
}

.v-stepper {
  box-shadow: none;
}

@media screen and (max-width: 480px) {
  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  h5 {
    font-size: 14px;
  }

  .form {
    width: 100%;
  }
}

.lastForm {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>